module.exports = __webpack_public_path__ + "img/pwa-android.64a9b029.jpg";